function verificar(nivel, tipo_usuario) {
    let saida = false;
    switch (nivel) {
        case 4:
            (tipo_usuario === 'agenciada1') ? saida = true : saida = false;
            break;

        case 5:
            (
                tipo_usuario === 'administrador' ||
                tipo_usuario === 'desenvolvedor' ||
                tipo_usuario === 'suportevendas1' ||
                tipo_usuario === 'suportevendas2' ||
                tipo_usuario === 'rep-weg' ||
                tipo_usuario === 'hseq6' ||
                tipo_usuario === 'hseq7') ? saida = true : saida = false;
            break;

        case 7:
            (
                tipo_usuario === 'administrador' ||
                tipo_usuario === 'desenvolvedor' ||
                tipo_usuario === 'suportevendas1' ||
                tipo_usuario === 'suportevendas2' ||
                tipo_usuario === 'agenciada1' ||
                tipo_usuario === 'hseq1' ||
                tipo_usuario === 'hseq2' ||
                tipo_usuario === 'hseq3' ||
                tipo_usuario === 'hseq4' ||
                tipo_usuario === 'hseq5' ||
                tipo_usuario === 'hseq6' ||
                tipo_usuario === 'hseq7' ||
                tipo_usuario === 'agente4' ||
                tipo_usuario === 'agente3' ||
                tipo_usuario === 'agente2' ||
                tipo_usuario === 'agente1') ? saida = true : saida = false;
            break;

        case 10:
            (
                tipo_usuario === 'administrador' ||
                tipo_usuario === 'desenvolvedor' ||
                tipo_usuario === 'suportevendas1' ||
                tipo_usuario === 'suportevendas2' ||
                tipo_usuario === 'agente4' ||
                tipo_usuario === 'agente3' ||
                tipo_usuario === 'agente2' ||
                tipo_usuario === 'agente1' ||
                tipo_usuario === 'hseq1' ||
                tipo_usuario === 'hseq2' ||
                tipo_usuario === 'hseq3' ||
                tipo_usuario === 'hseq4' ||
                tipo_usuario === 'hseq5' ||
                tipo_usuario === 'hseq6' ||
                tipo_usuario === 'hseq7') ? saida = true : saida = false;
            break;

        case 30:
            (
                tipo_usuario === 'administrador' ||
                tipo_usuario === 'desenvolvedor' ||
                tipo_usuario === 'suportevendas1' ||
                tipo_usuario === 'suportevendas2' ||
                tipo_usuario === 'agente4' ||
                tipo_usuario === 'agente3' ||
                tipo_usuario === 'hseq3' ||
                tipo_usuario === 'hseq4' ||
                tipo_usuario === 'hseq5' ||
                tipo_usuario === 'hseq6' ||
                tipo_usuario === 'hseq7') ? saida = true : saida = false;
            break;

        case 40:
            (
                tipo_usuario === 'administrador' ||
                tipo_usuario === 'desenvolvedor' ||
                tipo_usuario === 'suportevendas1' ||
                tipo_usuario === 'suportevendas2' ||
                tipo_usuario === 'agente4' ||
                tipo_usuario === 'hseq4' ||
                tipo_usuario === 'hseq5' ||
                tipo_usuario === 'hseq6' ||
                tipo_usuario === 'hseq7') ? saida = true : saida = false;
            break;
            
        case 44:
            (
                tipo_usuario === 'administrador' ||
                tipo_usuario === 'desenvolvedor' ||
                tipo_usuario === 'suportevendas1' ||
                tipo_usuario === 'suportevendas2' ||
                tipo_usuario === 'hseq5' ||
                tipo_usuario === 'hseq6' ||
                tipo_usuario === 'hseq7') ? saida = true : saida = false;
            break;
            
        case 45:
            (
                tipo_usuario === 'administrador' ||
                tipo_usuario === 'desenvolvedor' ||
                tipo_usuario === 'suportevendas1' ||
                tipo_usuario === 'suportevendas2' ||
                tipo_usuario === 'hseq6' ||
                tipo_usuario === 'hseq7') ? saida = true : saida = false;
            break;
            
        case 47:
            (
                tipo_usuario === 'administrador' ||
                tipo_usuario === 'desenvolvedor' ||
                tipo_usuario === 'suportevendas2' ||
                tipo_usuario === 'hseq7') ? saida = true : saida = false;
            break;

        case 50:
            (tipo_usuario === 'administrador' || tipo_usuario === 'desenvolvedor') ? saida = true : saida = false;
            break;

        case 60:
            (tipo_usuario === 'desenvolvedor') ? saida = true : saida = false;
            break;
    
        default:
            break;
    }

    return saida;
}

module.exports = { verificar };